import {
  default as FLOOD_ICON,
  default as FLOOD_NODE,
} from 'assets/FloodStageIcons/flood_stage_system.png';
import OVERWATCH_VMS from 'assets/icons/exacq.png';
import MANUAL_ROAD_CLOSURE from 'assets/map buttons/RescAlert Devices Manual Road Closures - Map Button.png';
import SIREN_GIANT_VOICE from 'assets/map buttons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) - Map button.png';
import TECHNOLOGY_BRIDGE from 'assets/map buttons/RescAlert Devices Technology Bridge - Map Button.png';
import { FaQuestion } from 'react-icons/fa';
import { Fa42Group, FaFireFlameCurved } from 'react-icons/fa6';
import { MdDeviceHub, MdDevices, MdGroupWork } from 'react-icons/md';
import { PiDevicesFill } from 'react-icons/pi';
import { RiBarChartGroupedLine, RiDeviceLine } from 'react-icons/ri';
import {
  TbDeviceAirtag,
  TbDeviceAnalytics,
  TbDeviceCctv,
  TbDeviceDesktopAnalytics,
} from 'react-icons/tb';
import RESCALERT_DEVICE from '../components/Nav/assets/Sidebar_Logo_Closed.png';

import L from 'leaflet';

//Flood Dynamic Icons
import stage_alarm_nocamera from 'assets/FloodStageIcons/stage_flooding.png';
import {
  default as stage_alarm_camera_cell,
  default as stage_alarm_camera_sat,
} from 'assets/FloodStageIcons/stage_flooding_camera.png';
import {
  default as stage_maintenance_no_camera,
  default as stage_offline_nocamera,
} from 'assets/FloodStageIcons/stage_offline.png';
import stage_maintenance_camera, {
  default as stage_offline_camera_cell,
  default as stage_offline_camera_sat,
} from 'assets/FloodStageIcons/stage_offline_camera.png';
import {
  default as stage_camera_cell,
  default as stage_camera_sat,
  default as stage_online_camera,
} from 'assets/FloodStageIcons/stage_online_camera.png';
import stage_slow_nocamera from 'assets/FloodStageIcons/stage_slow.png';
import {
  default as stage_slow_camera_cell,
  default as stage_slow_camera_sat,
} from 'assets/FloodStageIcons/stage_slow_camera.png';
import stage_warning_nocamera from 'assets/FloodStageIcons/stage_warning.png';
import {
  default as stage_warning_camera_cell,
  default as stage_warning_camera_sat,
} from 'assets/FloodStageIcons/stage_warning_camera.png';

//RescAlert Dynamic Icons
import rescalert from 'assets/resc_placeholder.png';
import rescalert_closure_closed from 'assets/rescalerticons/RescAlert Devices Manual Road Closures - Status Closed.png';
import rescalert_closure_open from 'assets/rescalerticons/RescAlert Devices Manual Road Closures - Status Open.png';
import rescalert_bridge_closed_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Closed (no camera).png';
import rescalert_bridge_closed_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Closed (with camera).png';
import rescalert_bridge_maintenance_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Maintenance (no camera).png';
import rescalert_bridge_maintenance_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Maintenance (with camera).png';
import rescalert_bridge_offline_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Offline (no camera).png';
import rescalert_bridge_offline_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Offline (with camera).png';
import rescalert_bridge_open_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Open (no camera).png';
import rescalert_bridge_open_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Open (with camera).png';
import rescalert_bridge_warning_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Warning (no camera).png';
import rescalert_bridge_warning_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge - Status Warning (with camera).png';

import rescalert_siren_alerting_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Alerting with camera.png';
import rescalert_siren_alerting_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Alerting.png';
import rescalert_siren_idle_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Idle with camera.png';
import rescalert_siren_idle_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Idle.png';
import rescalert_siren_maintenance_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Maintenance with camera.png';
import rescalert_siren_maintenance_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Maintenance.png';
import rescalert_siren_offline_camera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Offline with camera.png';
import rescalert_siren_offline_nocamera from 'assets/rescalerticons/RescAlert Devices Technology Bridge (Sirens-Giant Voice) Offline.png';
import { image } from 'd3';
import { makeUSGSMarker } from 'features/integrations/features/ConnectedDevices/features/DeviceMap/features/utils/USGSMarkerUtils';
import { DeviceIsSystemType } from 'features/integrations/utils/deviceComparisionUtils';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { GiBigWave } from 'react-icons/gi';

export const iconList = (size = 30) => [
  <MdDeviceHub size={size} />,
  <MdDevices size={size} />,
  <RiDeviceLine size={size} />,
  <TbDeviceAirtag size={size} />,
  <TbDeviceDesktopAnalytics size={size} />,
  <TbDeviceCctv size={size} />,
  <PiDevicesFill size={size} />,
  <TbDeviceAnalytics size={size} />,
  <Fa42Group size={size} />,
  <RiBarChartGroupedLine size={size} />,
  <MdGroupWork size={size} />,
  <FaFireFlameCurved size={size} />,
];

export const group_icon = (id, size = 30) => {
  const icons = iconList(size);
  return icons[id] || <FaQuestion size={size} />;
};

export const deviceImageList = {
  Flood: FLOOD_ICON,
  Stage: FLOOD_NODE,
  'RescAlert Devices': RESCALERT_DEVICE,
  RESCALERT: RESCALERT_DEVICE,
  'Manual Road Closure': MANUAL_ROAD_CLOSURE,
  'Technology Bridge_Flashing Lights': TECHNOLOGY_BRIDGE,
  'Technology Bridge_Siren/Giant Voice': SIREN_GIANT_VOICE,
  'Overwatch VMS': OVERWATCH_VMS,
  'Exacq Vision': OVERWATCH_VMS,
  USGS:
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
      renderToStaticMarkup(React.createElement(GiBigWave, { color: 'white', size: 35 })),
    ),
};

export const getDeviceListForGroup = (group) => {
  if (group.type) return deviceImageList[group.type];
  else if (group.controllers?.length > 0) return deviceImageList['Stage'];
  else return deviceImageList['RESCALERT'];
};

const iconSizes = [50, 50];

export const getDynamicDeviceIcon = (device, type = 'img', size = iconSizes) => {
  let icon = rescalert;
  switch (device?.system_type) {
    case 'Flood':
      icon = getFloodImage(device);
      size = [30, 60];
      break;
    case 'RescAlert Devices':
      icon = getRescAlertImage(device);
      break;
    case 'Exacq Vision':
      icon = OVERWATCH_VMS;
      size = [30, 30];
      break;
    case 'USGS':
      icon = makeUSGSMarker(device, undefined);
      size = [30, 30];
      break;
    default:
      icon = rescalert;
      size = [50, 50];
      break;
  }

  try {
    if (type === 'icon') {
      icon = imageToIcon(icon, size);
    }
  } catch (e) {
    console.error('Error for imageToIcon:', e, 'using default icon.');
    icon = imageToIcon(rescalert, [50, 50]);
  }

  return icon || <FaQuestion />;
};

export const getDynamicDeviceIconFromType = (systemType, deviceType, size = iconSizes) => {
  if (DeviceIsSystemType({ system_type: systemType }, 'Flood'))
    return imageToIcon(stage_online_camera, [30, 60]);
  else if (systemType.toLowerCase() === 'rescalert devices')
    switch (deviceType) {
      case 'Technology Bridge_Flashing Lights':
        return imageToIcon(rescalert_bridge_open_nocamera, size);
      case 'Technology Bridge_Siren/Giant Voice':
        return imageToIcon(rescalert_siren_idle_nocamera, size);
      case 'Manual Road Closure':
        return imageToIcon(rescalert_closure_open, size);
      default:
        break;
    }
  else if (systemType.toLowerCase() === 'exacq vision') return imageToIcon(OVERWATCH_VMS, size);

  return imageToIcon(rescalert, size);
};

export const imageToIcon = (image, size, anchor) => {
  return L.icon({
    iconUrl: image,
    iconSize: size,
  });
};

export function getDeviceStatusCode(device) {
  if (!device) return;
  if (DeviceIsSystemType(device, 'Flood')) return awareNodeStatus(device);
  if (device.system_type === 'RescAlert Devices') return getRescAlertStatus(device);
  //console.log("getDeviceStatusCode:", device);
  if (device.system_type === 'Exacq Vision') return getExacqVisionStatus(device);
}

//FLOOD DEVICE FUNCTIONS
function getFloodImage(device) {
  let status = 'Online';

  const deviceDataArray = Array.isArray(device.data) ? device.data : []; // Ensures that device data is always an array
  if (deviceDataArray.length === 0) return stage_offline_nocamera;

  const sortedDeviceData = [...deviceDataArray].sort((a, b) => b.ts - a.ts); // Created a sorted copy of the data
  if (!sortedDeviceData[0]) return stage_offline_nocamera; // Deals with null and undefined entries

  status = awareNodeStatus({ ...device }); // Pass a copy to avoid mutation

  if (status === 'Offline') {
    return device?.data[0].gatewayType
      ? stage_offline_camera_cell
      : device?.data[0]?.pict
        ? stage_offline_camera_sat
        : stage_offline_nocamera;
  }

  if (status === 'Slow') {
    return device?.data[0].gatewayType
      ? stage_slow_camera_cell
      : device?.data[0]?.pict
        ? stage_slow_camera_sat
        : stage_slow_nocamera;
  }

  if (status === 'Warning') {
    return device?.data[0].gatewayType
      ? stage_warning_camera_cell
      : device?.data[0]?.pict
        ? stage_warning_camera_sat
        : stage_warning_nocamera;
  }

  if (status === 'Flooding') {
    if (device?.data[0]?.pict) {
      return device?.data[0].gatewayType ? stage_alarm_camera_cell : stage_alarm_camera_sat;
    }
    return stage_alarm_nocamera;
  }

  if (status === 'Maintenance') {
    if (device?.data[0]?.pict) {
      return device?.data[0].gatewayType ? stage_maintenance_camera : stage_maintenance_no_camera;
    }
    return stage_alarm_nocamera;
  }

  if (device?.data[0]?.pict) {
    return device?.data[0].gatewayType ? stage_camera_cell : stage_camera_sat;
  }

  return stage_online_camera;
}

function awareNodeStatus(device) {
  if (device.reporting_mode === 'Offline') return device.reporting_mode;

  const currentTime = Date.now();

  const dataArray = Array.isArray(device.data) ? device.data : [];
  const info = dataArray[0];
  if (!info) return 'Offline';
  const settings = device.device_settings || {};

  let status = device.reporting_mode;
  if (
    // info.depthInd ||
    info.depth1 >= settings?.depthDet2 ||
    info.depth1 >= settings?.depthDet3
  ) {
    status = 'Flooding';
  } else if (info.ffi1) {
    return 'Rising';
  } else if (info.drInd) {
    return 'Dropping';
  } else if (info.depth1 >= settings.depthDet1) {
    status = 'Warning';
  }

  return status;
}

//RESCALERT DEVICE FUNCTIONS

/**
 * Gets the appropriate RescAlert image based on device data and status
 *
 * MRC defaults to open |
 * Tech Bridge defaults to offline
 *
 * @param   {[device]}  device  [device to get image for]
 *
 * @return  {[url]}        [image to use for device icon]
 */
function getRescAlertImage(device) {
  try {
    if (device?.data?.length > 0) {
      const info = device?.data[0];
      const status = getRescAlertStatus(device);

      switch (device.device_type) {
        case 'Manual Road Closure':
          return info?.status ? rescalert_closure_closed : rescalert_closure_open;
        case 'Technology Bridge_Flashing Lights':
          switch (status) {
            case 'Warning':
              return info?.pict
                ? rescalert_bridge_warning_camera
                : rescalert_bridge_warning_nocamera;
            case 'Maintenance':
              return info?.pict
                ? rescalert_bridge_maintenance_camera
                : rescalert_bridge_maintenance_nocamera;
            case 'Closed':
              return info?.pict ? rescalert_bridge_closed_camera : rescalert_bridge_closed_nocamera;
            case 'Offline':
              return info?.pict
                ? rescalert_bridge_offline_camera
                : rescalert_bridge_offline_nocamera;
            case 'Open':
              return info?.pict ? rescalert_bridge_open_camera : rescalert_bridge_open_nocamera;
            default:
              return info?.pict
                ? rescalert_bridge_offline_camera
                : rescalert_bridge_offline_nocamera;
          }
        case 'Technology Bridge_Siren/Giant Voice':
          switch (status) {
            case 'Maintenance':
              return info?.pict
                ? rescalert_siren_maintenance_camera
                : rescalert_siren_maintenance_nocamera;
            case 'Alerting':
              return info?.pict
                ? rescalert_siren_alerting_camera
                : rescalert_siren_alerting_nocamera;
            case 'Offline':
              return info?.pict ? rescalert_siren_offline_camera : rescalert_siren_offline_nocamera;
            case 'Idle':
              return info?.pict ? rescalert_siren_idle_camera : rescalert_siren_idle_nocamera;
            default:
              return info?.pict ? rescalert_siren_offline_camera : rescalert_siren_offline_nocamera;
          }
        default:
          //!! IF NO IMAGE RETURN THEN SEND BACK THE DEFAULT GENERIC DEFAULT RESCALERT ICON
          return rescalert;
      }
    }
    //Final catch all if no data available
    else {
      switch (device.device_type) {
        case 'Manual Road Closure':
          return rescalert_closure_open;
        case 'Technology Bridge_Flashing Lights':
          return rescalert_bridge_offline_nocamera;
        case 'Technology Bridge_Siren/Giant Voice':
          return rescalert_siren_offline_nocamera;
        default:
          //!! IF NO IMAGE RETURN THEN SEND BACK THE DEFAULT GENERIC DEFAULT RESCALERT ICON
          return rescalert;
      }
    }
  } catch (e) {
    console.error('Error in getRescAlertImage:', e);
  }
}

export function displayStatusOptions(device) {
  if (
    device?.device_type == 'Technology Bridge_Siren/Giant Voice' ||
    device?.deviceType == 'RescAlert Devices Technology Bridge_Siren/Giant Voice'
  ) {
    return {
      0: 'Idle',
      1: 'Alerting',
      '-1': 'Maintenance',
    };
  }
  return {
    0: 'Open',
    1: 'Closed',
    '-1': 'Warning',
  };
}

export function getRescAlertStatus(device) {
  const info = device?.data?.[0];
  if (device?.is_offline || !info || info?.is_offline) return 'Offline';

  const { device_type, kill_switch } = device;
  const statusVal = info.status;

  // --- Manual Road Closure ---
  if (device_type === 'Manual Road Closure') {
    return info.status ? 'Closed' : 'Open';
  }

  // --- Technology Bridge devices ---
  if (
    device_type === 'Technology Bridge_Flashing Lights' ||
    device_type === 'Technology Bridge_Siren/Giant Voice'
  ) {
    if (kill_switch || statusVal === -1) return 'Maintenance';
    if (statusVal === -2) return 'Offline';
    if (statusVal === -3) return 'API Error';

    const techBridgeStatusMap = {
      'Technology Bridge_Flashing Lights': { 0: 'Open', 1: 'Closed' },
      'Technology Bridge_Siren/Giant Voice': { 0: 'Idle', 1: 'Alerting' },
    };

    return techBridgeStatusMap[device_type][statusVal] || 'Unknown';
  }

  // --- Overwatch VMS ---
  if (device_type === 'Overwatch VMS') {
    return device.is_offline ? 'Offline' : 'Online';
  }

  // --- Generic fallback ---
  switch (statusVal) {
    case -1:
      return 'Maintenance';
    case -2:
      return 'Offline';
    case -3:
      return 'API Error';
    case 0:
      return 'Inactive';
    case 1:
      return 'Active';
    default:
      return 'Unknown';
  }
}

export function getExacqVisionStatus(device) {
  if (device.isOffline) return 'Offline';
  else return 'Online';
}
